import gql from 'graphql-tag';

export const getOutletQL = gql`
  query ($id: ID!) {
    outlet(id: $id) {
      id
      name
      address
      lat
      lon
    }
  }
`;

export const getRetailerQL = gql`
  query ($id: ID!) {
    retailer(id: $id) {
      id
      name
      logo(width: 300, height: 80) {
        id
        url
      }
      country
      outlets {
        id
        name
        address
      }
    }
  }
`;
